import "@components/ag-grid/styles/AgGrid.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useState } from "react";
import {
  FintracJobRun,
  FintracReport,
} from "@services/models/Fintrac/FintracModel";
import JobRunsScreen from "./JobRunsScreen";
import ReportsScreen from "./ReportsScreen";
import TransactionsScreen from "./TransactionsScreen";

type FintracScreen = "jobs" | "reports" | "transactions";

const Fintrac = () => {
  const [screen, setScreen] = useState<FintracScreen>("jobs");
  const [job, setJob] = useState<FintracJobRun | null>(null);
  const [report, setReport] = useState<FintracReport | null>(null);

  const layerClass = (active: boolean) =>
    active
      ? "h-full"
      : "pointer-events-none invisible absolute inset-0";

  return (
    <div className="relative h-screen overflow-hidden">
      <div className={layerClass(screen === "jobs")}>
        <JobRunsScreen
          onOpen={(nextJob) => {
            if (job?.id !== nextJob.id) {
              setReport(null);
            }
            setJob(nextJob);
            setScreen("reports");
          }}
        />
      </div>
      {job && (
        <div className={layerClass(screen === "reports")}>
          <ReportsScreen
            key={job.id}
            job={job}
            onBack={() => setScreen("jobs")}
            onOpen={(nextReport) => {
              setReport(nextReport);
              setScreen("transactions");
            }}
          />
        </div>
      )}
      {job && report && (
        <div className={layerClass(screen === "transactions")}>
          <TransactionsScreen
            key={report.id}
            job={job}
            report={report}
            onBackToJobs={() => setScreen("jobs")}
            onBackToReports={() => setScreen("reports")}
          />
        </div>
      )}
    </div>
  );
};

export default Fintrac;
